import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MasterDeviceAssignmentDto } from '../../../../../api/gen';

@Component({
  selector: 'app-master-controller-item',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  templateUrl: './master-controller-item.component.html',
  styleUrl: './master-controller-item.component.scss'
})
export class MasterControllerItemComponent {
  @Input() assignment!: MasterDeviceAssignmentDto;
  @Input() isDeleting = false;

  @Output() edit = new EventEmitter<MasterDeviceAssignmentDto>();
  @Output() delete = new EventEmitter<MasterDeviceAssignmentDto>();

  get assignmentTypeLabel(): string {
    switch (this.assignment.assignmentType) {
      case 'InfrastructureWide': return 'Infrastructure-wide';
      case 'GroupSpecific': return 'Group-specific';
      default: return 'N/A';
    }
  }

  onEdit(): void {
    this.edit.emit(this.assignment);
  }

  onDelete(): void {
    this.delete.emit(this.assignment);
  }
}
